// removed by extract-text-webpack-plugin
module.exports = {"car-details":"CarDetails-module-car-details-1O_Oo","carDetails":"CarDetails-module-car-details-1O_Oo","loader":"CarDetails-module-loader-3VSaA","button":"CarDetails-module-button-2tzQ2","icon":"CarDetails-module-icon-33odC","is-opened":"CarDetails-module-is-opened-28aGw","isOpened":"CarDetails-module-is-opened-28aGw","content":"CarDetails-module-content-1BeX0","listing":"CarDetails-module-listing-5Sy31","item":"CarDetails-module-item-3uRnZ","column":"CarDetails-module-column-2YS17","label":"CarDetails-module-label-CyZK7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CarDetails/CarDetails.module.scss
// module id = 1017
// module chunks = 0